"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _loadingIndicator = require("./loading-indicator.style");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function LoadingIndicator(_a) {
  var {
      className = 'loadingIndicator',
      variant = 'spinner',
      hiddenlabel = false,
      label,
      appearance = 'default',
      fit = 'medium',
      id,
      orientation = 'vertical'
    } = _a,
    rest = __rest(_a, ["className", "variant", "hiddenlabel", "label", "appearance", "fit", "id", "orientation"]);
  return (0, _jsxRuntime.jsxs)(_loadingIndicator.Components.LoaderWrapper, (0, _extends2["default"])({
    className: className,
    variant: variant,
    fit: fit,
    role: "status",
    "aria-label": label,
    id: id,
    appearance: appearance,
    orientation: orientation
  }, rest, {
    children: [variant === 'spinner' && (0, _jsxRuntime.jsx)(_loadingIndicator.Components.SpinnerIndicator, (0, _extends2["default"])({
      title: variant,
      fit: fit,
      appearance: appearance
    }, {
      children: (0, _jsxRuntime.jsxs)("svg", (0, _extends2["default"])({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, {
        children: [(0, _jsxRuntime.jsx)("circle", {
          className: "track",
          cx: "50",
          cy: "50",
          fill: "none",
          r: "40"
        }), (0, _jsxRuntime.jsx)("circle", {
          className: "spinner",
          cx: "50",
          cy: "50",
          fill: "none",
          r: "40",
          strokeDasharray: "55 200"
        })]
      }))
    })), variant === 'bar' && (0, _jsxRuntime.jsx)(_loadingIndicator.Components.BarIndicator, {
      title: variant,
      fit: fit,
      appearance: appearance
    }), !hiddenlabel && (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: (0, _jsxRuntime.jsx)(_loadingIndicator.Components.Label, (0, _extends2["default"])({
        appearance: appearance
      }, {
        children: label
      }))
    })]
  }));
}
var _default = exports["default"] = LoadingIndicator;